// extracted by mini-css-extract-plugin
export default {"resume-file":"styles_resume-file__JVfPN"};